import { commonOptions } from 'amb_base/options/common.options';
import initDragToClose from 'honda_cars_ecux/utils/popupDragClose';
var frontendUtils = require('honda_cars_ecux/utils/frontendUtils');

export default {
  dragToClose() {
    $('body')
      .on('show.bs.modal', (event) => {
        const { target } = event;

        target.destroyDisclaimerDrag = initDragToClose(target.querySelector('.modal-dialog'), {
          breakpoint: commonOptions.breakpoints.sm,
          scrollableSelector: () => {
            const view = target.dataset.view;
            if (view) {
              const scrollable = target.querySelector(`.modal-view[view="${view}"] .modal-body`);
              if (scrollable) {
                return scrollable;
              }
            }

            return target.querySelector('.modal-body');
          },
          allowDragClose: () =>
            !target.classList.contains('configurator-modal') ||
            !!frontendUtils.getCookie('userloc'),
          onClose: () => $(target).modal('hide')
        });
      })
      .on('hide.bs.modal', (event) => {
        const { target } = event;

        if (typeof target.destroyDisclaimerDrag === 'function') {
          target.destroyDisclaimerDrag();
          delete target.destroyDisclaimerDrag;
        }
      })
    ;
  }
};
